import {
  Table as UITable,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatToBRL } from "@/utils/formatToMoney";

import type { IAggregationByBank } from "src/@types/deposit-reconciliation";

import { sumAmountsInCents } from "./sum-in-cents";

export default function AggregationByBank({
  rows,
}: {
  rows: IAggregationByBank[];
}) {
  const total = {
    conc: sumAmountsInCents(rows, r => r.conciliado),
    ab: sumAmountsInCents(rows, r => r.aberto),
    total: sumAmountsInCents(rows, r => r.total),
  };

  return (
    <div className="border border-slate-200 rounded-md bg-white">
      <div className="border-b border-slate-200 px-3 py-2 bg-slate-50">
        <h3 className="font-semibold text-sm text-slate-700">Por Banco</h3>
      </div>
      <UITable>
        <TableHeader>
          <TableRow>
            <TableHead className="text-xs">Banco</TableHead>
            <TableHead className="text-xs text-right">Conciliado</TableHead>
            <TableHead className="text-xs text-right">Em aberto</TableHead>
            <TableHead className="text-xs text-right">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-xs text-center text-slate-500">
                Sem dados
              </TableCell>
            </TableRow>
          ) : (
            <>
              {rows.map(r => (
                <TableRow key={r.bankCode}>
                  <TableCell className="text-xs">
                    {r.bankName}
                  </TableCell>
                  <TableCell className="text-xs text-right">
                    {formatToBRL(r.conciliado)}
                  </TableCell>
                  <TableCell className="text-xs text-right">
                    {formatToBRL(r.aberto)}
                  </TableCell>
                  <TableCell className="text-xs text-right font-medium">
                    {formatToBRL(r.total)}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow className="bg-slate-50 font-semibold border-t-2 border-[#2B0C1A]">
                <TableCell className="text-xs">TOTAL</TableCell>
                <TableCell className="text-xs text-right">
                  {formatToBRL(total.conc)}
                </TableCell>
                <TableCell className="text-xs text-right">
                  {formatToBRL(total.ab)}
                </TableCell>
                <TableCell className="text-xs text-right">
                  {formatToBRL(total.total)}
                </TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </UITable>
    </div>
  );
}
